module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_100000_250000.9412eb7f.png";